import { render } from "./Blocked_Persons.vue?vue&type=template&id=03c68eee"
import script from "./Blocked_Persons.vue?vue&type=script&lang=js"
export * from "./Blocked_Persons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__